


































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import TreeSelect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import ControlDto from "@/store/entities/devices/switchs/controldto";

@Component({
  components: { TreeSelect },
})
export default class DivertUser extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  @Prop({ type: Array, default: [] }) userId: any[];
  @Prop({ type: Array, default: [] }) userName: any[];
  entity: ControlDto = new ControlDto();
  loading: boolean = false;
  async created() {
    await this.itemtree();
  }
  async itemtree() {
    await this.$store
      .dispatch("tenant/getAllTenants")
      .then((val) => {
        if (val[0].children.length > 0) {
          val[0].children.forEach((ele) => {
            this.$data.tenantslist.push({ value: ele.id, label: ele.title });
          });
        }
      })
      .catch((err) => {
        //return null;
      });
  }
  //保存
  save() {
    (this.$refs.meterModelForm as any).validate(async (valid: boolean) => {
      if (valid) {
        this.loading = true;
        let res = await this.$store
          .dispatch({
            type: "tenantuser/transferTenant",
            data: this.entity,
          })
          .catch((err) => {
            this.loading = false;
            this.$Modal.info({
              title: this.L("Tips"),
              content: err,
            });
          });
        this.$Modal.info({
          title: this.L("Tips"),
          content: res,
        });
        this.loading = false;
        (this.$refs.meterModelForm as any).resetFields();
        this.$emit("save-success");
        this.$emit("input", false);
      }
    });
  }
  cancel() {
    (this.$refs.meterModelForm as any).resetFields();
    this.$emit("input", false);
  }
  async visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    }
  }
  modelRule = {
    targetTenantId: [
      {
        required: true,
        message: this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
  };
  data() {
    return {
      tenantslist: [], //租户
      normalizer(node) {
        if (node.children && !node.children.length) {
          delete node.children;
        }
        return {
          id: node.id,
          label: node.label,
          children: node.children,
        };
      },
    };
  }
  @Watch("userId", { deep: true })
  @Watch("userName", { deep: true })
  getitemId() {
    this.entity.userId = this.userId;
    this.entity.userName = "";
    this.userName.forEach((ele) => {
      if (this.entity.userName.length == 0) {
        this.entity.userName = ele;
      } else {
        this.entity.userName = this.entity.userName + ";" + ele;
      }
    });
  }
}
